module.exports = __webpack_public_path__ + "static/media/textLogo.6b3b327d.svg";